module.exports = __webpack_public_path__ + "img/sheng.3909796e.svg";